import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMask1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconMask1"><Path fillRule="evenodd" clipRule="evenodd" d="M12.1992 3.02734L20 5.17871V7.5H22.75V13.5H20V15.4951C19.9998 16.5503 19.3956 17.5119 18.4453 17.9707L12 21.083L5.55469 17.9707C4.60439 17.5119 4.00018 16.5503 4 15.4951V13.5H1.25V7.5H4V5.17871L11.8008 3.02734L12 2.97168L12.1992 3.02734ZM9 14.5H15V13H9V14.5ZM2.75 12H4V9H2.75V12ZM20 12H21.25V9H20V12ZM9 10.5H15V9H9V10.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconMask1;
